export function getClosestPageBlockComponent(el) {
    return el.closest('affine-edgeless-page, affine-page-block');
}
//# sourceMappingURL=query.js.map